// extracted by mini-css-extract-plugin
module.exports = {"default-color":"TextHighlighter_default-color__37ey5","highlight":"TextHighlighter_highlight__2o1Qq","bold":"TextHighlighter_bold__1OHRw"};